import ProtectedRoute from "@components/ProtectedRoute";
import { useIsInclude } from "src/router/RoutersCst";
import SkillsCorporate from "@pages/Contents/Corporate/Skills";
import FoundedTrainingCorporate from "@pages/Contents/Corporate/FoundedTraining";
import ManagePlan from "@pages/Contents/Corporate/FoundedTraining/ManagePlan";
import EditPlan from "@pages/Contents/Corporate/FoundedTraining/ManagePlan/PlanEdit";
import AddPlan from "@pages/Contents/Corporate/FoundedTraining/ManagePlan/PlanAdd";
import ManagePlanProjects from "@pages/Contents/Corporate/FoundedTraining/ManagePlan/Projects";
import EditProject from "@pages/Contents/Corporate/FoundedTraining/ManagePlan/Projects/ProjectEdit";
import AddProject from "@pages/Contents/Corporate/FoundedTraining/ManagePlan/Projects/ProjectAdd";
import ManageProjectModules from "@pages/Contents/Corporate/FoundedTraining/ManagePlan/Modules";
import ModuleEdit from "@pages/Contents/Corporate/FoundedTraining/ManagePlan/Modules/ModuleEdit";
import ModuleAdd from "@pages/Contents/Corporate/FoundedTraining/ManagePlan/Modules/ModuleAdd";
import CatalogObj from "@pages/Contents/Corporate/FoundedTraining/ManagePlan/Modules/CatalogObj";

const useCorporateFoundedTraining = () => {
  const { isInclude } = useIsInclude();

  return {
    path: "foundedTraining",
    children: [
      {
        index: true,
        path: "",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("usermgmt.corporates.funded_training.read")}
          >
            <FoundedTrainingCorporate />
          </ProtectedRoute>
        ),
      },
      {
        path: "managePlan",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("usermgmt.corporates.funded_training.read")}
          >
            <ManagePlan />
          </ProtectedRoute>
        ),
      },
      {
        path: "managePlan/edit/:IdPlan",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("usermgmt.corporates.funded_training.write")}
          >
            <EditPlan></EditPlan>
          </ProtectedRoute>
        ),
      },
      {
        path: "managePlan/add",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("usermgmt.corporates.funded_training.write")}
          >
            <AddPlan></AddPlan>
          </ProtectedRoute>
        ),
      },
      {
        path: "managePlan",
        children: [
          {
            index: true,
            path: ":IdPlan/projects",
            element: (
              <ProtectedRoute
                isAllowed={isInclude(
                  "usermgmt.corporates.funded_training.read",
                )}
              >
                <ManagePlanProjects></ManagePlanProjects>
              </ProtectedRoute>
            ),
          },
          {
            path: ":IdPlan/projects",
            children: [
              {
                index: true,
                path: "edit/:IdProject",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "usermgmt.corporates.funded_training.write",
                    )}
                  >
                    <EditProject></EditProject>
                  </ProtectedRoute>
                ),
              },
              {
                index: true,
                path: "add",
                element: (
                  <ProtectedRoute
                    isAllowed={isInclude(
                      "usermgmt.corporates.funded_training.write",
                    )}
                  >
                    <AddProject></AddProject>
                  </ProtectedRoute>
                ),
              },
              {
                path: "",
                children: [
                  {
                    index: true,
                    path: ":IdProject/modules",
                    element: (
                      <ProtectedRoute
                        isAllowed={isInclude(
                          "usermgmt.corporates.funded_training.read",
                        )}
                      >
                        <ManageProjectModules></ManageProjectModules>
                      </ProtectedRoute>
                    ),
                  },
                  {
                    path: ":IdProject/modules",
                    children: [
                      {
                        index: true,
                        path: "edit/:IdModule",
                        element: (
                          <ProtectedRoute
                            isAllowed={isInclude(
                              "usermgmt.corporates.funded_training.write",
                            )}
                          >
                            <ModuleEdit></ModuleEdit>
                          </ProtectedRoute>
                        ),
                      },
                      {
                        index: true,
                        path: "add",
                        element: (
                          <ProtectedRoute
                            isAllowed={isInclude(
                              "usermgmt.corporates.funded_training.write",
                            )}
                          >
                            <ModuleAdd></ModuleAdd>
                          </ProtectedRoute>
                        ),
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };
};

export default useCorporateFoundedTraining;
